import React from 'react';
import { DVConnectorModal } from './DVConnectorModal';
import { ECWPremiseModal } from './ECWPremise';
import { HJPremiseModal } from './HJPremiseModal';
import { AthenaModal } from './AthenaModal';
import { DrChronoModal } from './DrChronoModal';
import { VeradigmModal } from './VeradigmModal';
import { CernerModal } from './CernerModal';
import { EpicModal } from './EpicModal';
import { ElationHealthSimplePracticeModal } from './ElationHealthSimplePracticeModal';
import { NotSureModal } from './NotSureModal';
import { sendSlackAlert, SlackChannelEnum } from '../../../api/slack';
import { NextGenEnterpriseCloudModal } from './NextGenEnterpriseCloudModal';
import { HJCloudModal } from './HJCloudModal';
import { EmrEnvironment, EmrMethod } from '../../../../generated/tenant-api';

export const NextStepsWrapper = (props: {
    onClose: () => void;
    isOpen: boolean;
    eligibleForSelfServeTracker?: boolean;
    emr?: string | null;
    emrEnvironment?: string | null;
    fulfillmentMethod?: string | null;
}) => {
    if (!props.emr || !props.emrEnvironment || !props.fulfillmentMethod) {
        return <></>;
    } else if (props.emrEnvironment === EmrEnvironment.NOT_SURE) {
        return <NotSureModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.eligibleForSelfServeTracker) {
        return <DVConnectorModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'eClinicalWorks' && props.emrEnvironment === EmrEnvironment.ON_PREMISE) {
        return <ECWPremiseModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'Athena (AthenaOne)') {
        return <AthenaModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'Cerner Millennium') {
        return <CernerModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'EPIC') {
        return <EpicModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'DrChrono') {
        return <DrChronoModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'Veradigm EHR') {
        return <VeradigmModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'Elation Health' || props.emr === 'Simple Practice') {
        return <ElationHealthSimplePracticeModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (props.emr === 'NextGen Enterprise' && props.emrEnvironment === EmrEnvironment.CLOUD) {
        return <NextGenEnterpriseCloudModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (
        props.fulfillmentMethod === EmrMethod.HEALTHJUMP &&
        props.emrEnvironment === EmrEnvironment.ON_PREMISE
    ) {
        return <HJPremiseModal onClose={props.onClose} isOpen={props.isOpen} />;
    } else if (
        props.fulfillmentMethod === EmrMethod.HEALTHJUMP &&
        props.emrEnvironment === EmrEnvironment.CLOUD
    ) {
        return <HJCloudModal onClose={props.onClose} isOpen={props.isOpen} />;
    }
    console.error('No next steps modal match found');
    void sendSlackAlert(
        SlackChannelEnum.IDSB_PROVIDER_PRODUCT_ALERTS,
        `User is missing next steps modal match for EMR: ${props.emr}, EMR Environment: ${props.emrEnvironment}, Fulfillment Method: ${props.fulfillmentMethod}`
    );
    return <></>;
};
